import React from "react";
import * as R from "ramda";
// import NoteAddOutlinedIcon from "@material-ui/icons/NoteAddOutlined";
import {
  // TipsAndUpdatesIcon,
  Div
} from "components/Base";
import styles from "./styles.scss";
import CommentOutlinedIcon from "@material-ui/icons/CommentOutlined";
import { isEmptyOrNil, noop } from "utils/General";
import { connect } from "react-redux";
import classNames from "classnames";
// import Avatar from "Portal/NewPortal/Shared/Avatar";

import {
  getters as sliderSidebarGetters,
  actions as sliderSidebarActions
} from "Portal/NewPortal/Sections/Sessions/FlyOver/model";

import { StatusComponent } from "Portal/NewPortal/Sections/Home/Cards/Sessions/Session";
import {
  getBackgroundColor,
  getVisibleSessionFieldIds
} from "Portal/NewPortal/PortalHome/selectors";

import { bindInstance } from "redux-mvc";

// import { TAB_IDS } from "Portal/NewPortal/Sections/Sessions/FlyOver/constants";
import * as FIELD_IDS from "@sessionboard/sessionboard-value-types/src/constants/standard-module-field-ids";

import { getEnableContentUpload } from "Portal/NewPortal/Sections/Sessions/FlyOver/selectors";

const decorate = R.compose(
  connect(
    state => ({
      visibleSessionFieldIds: getVisibleSessionFieldIds(state),
      sessionDataSelected: sliderSidebarGetters.sessionData(state),
      backgroundColor: getBackgroundColor(state),
      enableContentUpload: getEnableContentUpload(state)
    }),
    bindInstance({
      openSessionFlyover: sliderSidebarActions.openSessionFlyover
    })
  )
);

const SessionCard = data => {
  if (R.isEmpty(data)) {
    return null;
  }
  const {
    visibleSessionFieldIds,
    status,
    name,
    open_label,
    // is_past_due,
    meta,
    id = null,
    isSubsession,
    // isReadOnly,
    // parentStatus,
    openSessionFlyover = noop,
    sessionDataSelected = {},
    // eventId = 123123,
    // eventName = "Collidian Ort",
    backgroundColor = null,
    enableContentUpload = false
  } = data || {};

  const {
    date = null,
    speakers = [],
    chairpersons = [],
    moderators = [],
    count_of_files = 0,
    location
    // completedTasks = 3
  } = meta || {};

  const { id: idSessionSelected = null } = sessionDataSelected || {};
  const cardClassName =
    idSessionSelected && idSessionSelected === id
      ? classNames(styles.card, "accentable-border-with-hover")
      : classNames("accentable-hover", styles.card);

  return (
    <div
      className={cardClassName}
      style={
        isSubsession
          ? {
              width: "90%",
              alignSelf: "flex-end",
              ...(backgroundColor ? { backgroundColor } : {})
            }
          : { ...(backgroundColor ? { backgroundColor } : {}) }
      }
      onClick={() => {
        openSessionFlyover({ sessionData: data });
      }}
    >
      <div className={styles.header}>
        <div className={styles.titleContainer}>
          <Div display="row" style={{ gap: "4px" }}>
            {/*
            <div className={styles.iconContainer}>
              <TipsAndUpdatesIcon color={"#FF922B"} />
            </div>
            */}
            <div className={styles.title}>{name}</div>
          </Div>
          <Div display="row" style={{ gap: "8px" }}>
            {/*
            {!isSubsession && (
              <div className={styles.eventIconContainer}>
                <div className={styles.eventIcon}>
                  <Avatar
                    id={eventId}
                    name={eventName}
                    type="small"
                    square={true}
                    longInitials={true}
                  />
                </div>
              </div>
            )}
            */}
            {enableContentUpload && (
              <div className={styles.notification}>
                <div className={styles.notificationBadge}>
                  {count_of_files || 0}
                </div>
                <div className={styles.notificationIcon}>
                  <CommentOutlinedIcon
                    style={{ fontSize: "16px", color: "#666666" }}
                  />
                </div>
              </div>
            )}
          </Div>
        </div>
        {/* <div className={styles.subtitle}></div> */}
      </div>
      <div className={styles.statusContainer}>
        <div className={styles.statusIcon}>
          <StatusComponent className={styles.statusIndicator} status={status} />
        </div>
        <div className={styles.statusText}>{open_label}</div>
      </div>
      <div className={styles.separator}></div>
      <div className={styles.details}>
        <div className={styles.participants}>
          {visibleSessionFieldIds.includes(FIELD_IDS.SESSIONS.STARTS_AT) &&
            visibleSessionFieldIds.includes(FIELD_IDS.SESSIONS.ENDS_AT) &&
            !isEmptyOrNil(date) && (
              <div className={styles.dateContainer}>
                <div className={styles.label}>Date:</div>
                <div className={styles.names}>{date}</div>
              </div>
            )}
          {visibleSessionFieldIds.includes(FIELD_IDS.SESSIONS.LOCATION) &&
            !isEmptyOrNil(location) && (
              <div className={styles.dateContainer}>
                <div className={styles.label}>Location:</div>
                <div className={styles.names}>{location}</div>
              </div>
            )}
          {visibleSessionFieldIds.includes(FIELD_IDS.SESSIONS.SPEAKERS) &&
            !isEmptyOrNil(speakers) && (
              <div className={styles.speakers}>
                <div className={styles.label}>Speakers:</div>
                <div className={styles.names}>{speakers}</div>
              </div>
            )}
          {visibleSessionFieldIds.includes(FIELD_IDS.SESSIONS.SPEAKERS) &&
            !isEmptyOrNil(chairpersons) && (
              <div className={styles.speakers}>
                <div className={styles.label}>Chairperson:</div>
                <div className={styles.names}>{chairpersons}</div>
              </div>
            )}
          {visibleSessionFieldIds.includes(FIELD_IDS.SESSIONS.SPEAKERS) &&
            !isEmptyOrNil(moderators) && (
              <div className={styles.moderator}>
                <div className={styles.label}>Moderator:</div>
                <div className={styles.names}>{moderators}</div>
              </div>
            )}
        </div>
        <div className={styles.dateUploadContainer}>
          {/* <div className={styles.room}>{location}</div>
          <div className={styles.uploadContainer}>
            <div className={styles.uploadIcon}>
              <NoteAddOutlinedIcon
                style={{ fontSize: "14px", color: "#4263eb" }}
              />
            </div>
            <div className={styles.uploadText}>Upload File</div>
          </div> */}
          {/*
          // Commenting out until session tasks in place
          {completedTasks > 0 && (
            <div
              className={styles.taskContainer}
              onClick={() => {
                openSessionFlyover({
                  sessionData: data,
                  initTab: TAB_IDS.TASKS
                });
              }}
            >
              <div className={styles.taskIndicator}>
                <i
                  class="material-symbols-outlined"
                  style={{
                    color: "#494949",
                    fontSize: "16px",
                    fontWeight: "600"
                  }}
                >
                  check_circle
                </i>
              </div>
              <div className={styles.taskText}>
                Complete Tasks ({completedTasks})
              </div>
            </div>
          )}
          */}
        </div>
      </div>
    </div>
  );
};

export default decorate(SessionCard);
